export default __webpack_public_path__ + "static/media/chart.2f257417.svg";